<template>
    <div>
        <div class="float-left mr-1">
            <span class="text-info" @click.stop="abrirModal()">
                <i
                    class="fa fa-pie-chart fa-lg icon-button"
                    title="Listar Parcelas"
                ></i>
            </span>
        </div>

        <b-modal
            v-model="showModal"
            id="modalListarParcelasMovimentacoesMinimas"
            size="lg"
            hide-footer
        >
            <div slot="modal-title">
                Parcelas das Movimentações Mínimas - CONTRATO {{ codigoContrato }}
            </div>
            <parcelas-movimentacoes-minimas
                :movimentacao="movimentacao"
                :showModal="showModal"
                @modalFechado="showModal = false"
                @obterMovimentacoesAtualizadas="$emit('obterMovimentacoesAtualizadas')"
            ></parcelas-movimentacoes-minimas>
        </b-modal>
    </div>
</template>


<script>

import ParcelasMovimentacoesMinimas from './ParcelasMovimentacoesMinimas'

export default {
    
    components: {
        ParcelasMovimentacoesMinimas
    },

    props: {
        movimentacao: {
            type: Object,
            default: {}
        },
        codigoContrato: {
            type: String,
            default: ''
        }
    },

    data() {
		return {
			showModal: false            
		}
	},

	methods: {
		abrirModal() {
			this.showModal = true
		}
	},


}

</script>

